/**
 * Единое форматирование текстов МСК Газобетона.
 *
 * Только представление: наименования, числа и суммы приходят готовыми, здесь их
 * не пересчитывают и не переименовывают по смыслу. Правки касаются написания —
 * размеры через знак умножения, название производства обычным регистром.
 */

// В номенклатуре размеры пишут через латинскую «x» или кириллическую «х»:
// «300x250x625», «300х250х625». В документах это знак умножения.
const DIMENSION_SEPARATOR = /(\d)\s*[xхXХ]\s*(?=\d)/g;

/** «Газобетон D400 300x250x625 мм» → «Газобетон D400 300×250×625 мм». */
export const formatNomenclatureName = (name) => {
  const text = String(name ?? '').trim();
  if (!text) {
    return '';
  }
  // Два прохода: в «300x250x625» второй разделитель стоит вплотную к результату первого.
  return text.replace(DIMENSION_SEPARATOR, '$1×').replace(DIMENSION_SEPARATOR, '$1×');
};

/**
 * Название производства обычным регистром. КАПС из данных не воспроизводим,
 * но и не ломаем аббревиатуры вроде «ЛСР» и «КСИ» — трогаем только слова,
 * набранные заглавными целиком и длиннее трёх букв.
 */
export const formatProductionName = (production) => {
  const text = String(production ?? '').trim();
  if (!text) {
    return '';
  }

  return text.replace(/[А-ЯЁA-Z][А-ЯЁA-Z]+/g, (word) => (
    word.length > 3 ? word[0] + word.slice(1).toLowerCase() : word
  ));
};

/** Разряды обычным пробелом: неразрывный ломает вставку в мессенджер. */
export const formatMoney = (value) => (
  String(Math.ceil(Number(value) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
);

/** Единица измерения в читаемом тексте: «м3» из данных пишется как «м³». */
export const formatUnit = (unit) => {
  const value = String(unit ?? '').trim();
  return value === 'м3' ? 'м³' : value;
};

/** Дробная часть через запятую, целые — без хвоста. */
export const formatNumber = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return null;
  }
  const rounded = Math.round(num * 1000) / 1000;
  return rounded % 1 === 0 ? String(rounded) : String(rounded).replace('.', ',');
};

export default formatNomenclatureName;
